/**
 * Icon — renders an SVG icon by name from the icon registry context.
 *
 * Sets both `color` and `fill` on the SVG element for cross-browser
 * compatibility (Firefox requires explicit fill; Chrome infers from color).
 */
import { type FC, memo } from "react";
import type { StyleProp, ViewStyle } from "react-native";
import "../theme";
import { useUnistyles } from "react-native-unistyles";
import type { IconName } from "../icons/icon-names";
import { useIconRegistry } from "../icons/IconContext";

export interface IconProps {
  readonly name: IconName;
  readonly size?: number;
  readonly color?: string;
  readonly style?: StyleProp<ViewStyle>;
}

export const Icon: FC<IconProps> = memo(function Icon({ name, size = 24, color, style }) {
  const { theme } = useUnistyles();
  const registry = useIconRegistry();
  const SvgIcon = registry[name];
  const resolvedColor = color ?? theme.colors.icon;

  return <SvgIcon width={size} height={size} color={resolvedColor} fill={resolvedColor} style={style} />;
});
